import { IdNameModel } from '@abb-procure/data';
import { BooleanInput } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  input,
  output,
} from '@angular/core';
import { Card } from '../card/card.component';

@Component({
  selector: 'procure-substatus-list',
  templateUrl: './substatus-list.component.html',
  styleUrl: './substatus-list.component.scss',
  imports: [Card],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubstatusList {
  readonly substatuses = input<IdNameModel[] | null>([]);
  readonly activeId = input<number>();

  readonly isLoading = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly isSaving = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly showMode = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly canEdit = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly update = output<IdNameModel>();
}
